import styled from 'styled-components';

const FiltersForm = styled.form`
  bottom: 0;
  margin: 0;
  max-height: 900px;
  padding-right: 10px;
  overflow-y: visible;
  margin-top: 10px;
  position: sticky;
  top: 210px;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
`;

export default FiltersForm;
